import React from "react";

import { Card, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBack from "@material-ui/icons/ArrowBack";
import { useHistory } from "react-router-dom";
import { getTokens } from "../../styles/tokens";

const useStyles = makeStyles((theme) => {
	const t = getTokens(theme.palette.type, theme.palette.primary.main);
	return {
		ticketHeader: {
			display: "flex",
			alignItems: "center",
			gap: 4,
			// barra do contato no padrão do WhatsApp Web: faixa cinza plana
			background: theme.palette.type === "dark" ? "#202c33" : "#f0f2f5",
			flex: "none",
			border: 0,
			borderRadius: 0,
			boxShadow: "none",
			height: 59,
			minHeight: 59,
			padding: "0 12px 0 8px",
			position: "relative",
			zIndex: 3,
			[theme.breakpoints.down("sm")]: {
				flexWrap: "wrap",
				height: "max-content",
				minHeight: 56,
				padding: "5px 7px",
			},
		},
		backButton: {
			width: 34,
			height: 34,
			padding: 0,
			borderRadius: "50%",
			margin: "0 2px 0 0",
			color: t.textSecondary,
			transition: "background-color 150ms ease, color 150ms ease",
			"&:hover": {
				backgroundColor: theme.palette.type === "dark" ? "rgba(233,237,239,0.1)" : "rgba(11,20,26,0.08)",
				color: t.text,
			},
			"& .MuiSvgIcon-root": {
				fontSize: 19,
			},
		},
	};
});

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBack = () => {

		history.push("/tickets");
	};

	// useEffect(() => {
	// 	const handleKeyDown = (event) => {
	// 		if (event.key === "Escape") {
	// 			handleBack();
	// 		}
	// 	};
	// 	document.addEventListener("keydown", handleKeyDown);
	// 	return () => {
	// 		document.removeEventListener("keydown", handleKeyDown);
	// 	};
	// }, [history]);

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card
					square
					elevation={0}
					className={classes.ticketHeader}
				>
					<IconButton className={classes.backButton} onClick={handleBack} aria-label="Voltar para a lista de conversas">
						<ArrowBack />
					</IconButton>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
